import React from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';

const ModalHeader = ({ title, onClose }) => {
  return (
    <div className="flex items-center justify-between text-primary font-semibold mb-4">
      <h2 className="text-md">{title}</h2>
      <AiOutlineCloseCircle
        className="cursor-pointer text-xl"
        onClick={onClose}
      />
    </div>
  );
};

export default ModalHeader;
